import { createContext } from 'react';

import type { StripePricesGetCurrency } from '@workspace/api';

export type Currency = StripePricesGetCurrency;

export interface CurrencyContextType {
    currency: Currency;
    setCurrency: (currency: Currency) => void;
}

export const CurrencyContext = createContext<CurrencyContextType | null>(null);
